import React from 'react';
import { useTranslation } from 'react-i18next';
import Navbar from '../components/Navigation/Navbar';
import SciFiBackground from '../components/SciFiBackground/SciFiBackground';
import BuyerOffersDashboard from '../components/BuyerOffersDashboard';
import PlatformPageHeader from '../components/Common/PlatformPageHeader';
import { Box, Container } from '@mui/material';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';

const MyOffersPage = () => {
  const { t } = useTranslation();
  
  return (
    <SciFiBackground>
      <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
        <Navbar />
        <Box component="main" sx={{ flex: 1, display: 'flex', py: { xs: 5, md: 8 }, px: 2 }}>
          <Container maxWidth="lg">
            <PlatformPageHeader
              icon={LocalOfferIcon}
              eyebrow={t('nav.myOffers', 'Offers')}
              title={t('myOffers.title')}
              subtitle={t('myOffers.subtitle')}
            />
            <BuyerOffersDashboard />
          </Container>
        </Box>
      </Box>
    </SciFiBackground>
  );
};

export default MyOffersPage;
